export default "__VITE_ASSET__d0e78356__"